module.exports = __webpack_public_path__ + "bed146276ea91073f86c4bd9e9eb25fb.svg";